var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"external-jump-page"},[_vm._v(" 跳转入口 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }